// ** Auth Endpoints
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  baseUrl: `${process.env.REACT_APP_API_URL_V2}/v2`,
  loginEndpoint: "/auth/login",
  registerEndpoint: "/jwt/register",
  refreshEndpoint: "/jwt/refresh-token",
  logoutEndpoint: "/jwt/logout",

  // ** This will be prefixed in authorization header with token
  // ? e.g. Authorization: Bearer <token>
  tokenType: "Bearer",

  // ** Value of this property will be used as key to store JWT token in storage
  storageTokenKeyName: "accessToken",
  storageRefreshTokenKeyName: "refreshToken",
};
